function gridcarousel(){
  if(typeof quickAddButton == 'function'){
    quickAddButton();
  }
  document.querySelectorAll('.lbo-dots').forEach(function(dotWrapper){
    dotWrapper.querySelectorAll('.lbo-dot').forEach(function(dot){
      dot.addEventListener('click', function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        let thisHandle = dot.getAttribute('data-handle');
        dotWrapper.querySelectorAll('.dot-prod').forEach(function(product){
          let prodHandle = product.getAttribute('data-handle');
          if(prodHandle == thisHandle){
            let dotWrap = product.closest('.lbo-dots-wrap');
            if(dotWrap.classList.contains('active-dot')){
              dotWrap.classList.remove('active-dot');
            }else{
              dotWrapper.querySelectorAll('.lbo-dots-wrap').forEach(function(productRemove){
                productRemove.classList.remove('active-dot');
              });
              dotWrap.classList.add('active-dot');
            }
          }
        });
      });
    });
  });
  document.querySelectorAll('.snippet-promo-image.desk-promo').forEach((promo) => {
    let prev = promo.previousSibling;
    promo.style.height = 'calc(100% - '+prev.querySelector('.grid-meta').clientHeight+'px)';
  })
  document.querySelectorAll('.metafield-colors li').forEach((color) => {
    color.addEventListener('mouseover',function(){
      if(color.getAttribute('data-image') || color.getAttribute('data-price') || color.getAttribute('data-compare-price') && color.closest('.snippet-product-grid') != null){
        color.closest('.snippet-product-grid').querySelector('.product-images img').setAttribute('srcset',color.getAttribute('data-image'));
        color.closest('.snippet-product-grid').querySelector('.grid-meta .regular-price').textContent = color.getAttribute('data-price');
        color.closest('.snippet-product-grid').querySelector('.grid-meta .compare-price').textContent = color.getAttribute('data-compare-price');
      }
    })
    color.addEventListener('mouseout',function(){
      if(color.closest('.metafield-colors').querySelector('li.active').getAttribute('data-image') || color.closest('.metafield-colors').querySelector('li.active').getAttribute('data-price') ||  color.closest('.metafield-colors').querySelector('li.active').getAttribute('data-compare-price') && color.closest('.snippet-product-grid') != null){
        color.closest('.snippet-product-grid').querySelector('.product-images img').setAttribute('srcset',color.closest('.metafield-colors').querySelector('li.active').getAttribute('data-image'));
        color.closest('.snippet-product-grid').querySelector('.grid-meta-price .regular-price').textContent = color.closest('.metafield-colors').querySelector('li.active').getAttribute('data-price');
        color.closest('.snippet-product-grid').querySelector('.grid-meta-price .compare-price').textContent = color.closest('.metafield-colors').querySelector('li.active').getAttribute('data-compare-price');
      }
    })
  })
}
setTimeout(function(){
  gridcarousel();
  window.addEventListener("resize", gridcarousel);
},500)
var advance = function() {
  gridcarousel();
}
// var infinitescroll = {
//   scolljs: function(){
//     var endlessScroll = new Ajaxinate({
//       container: '#product-grid',
//       pagination: '#AjaxinatePagination',
//       callback: advance,
//       offset:1000
//     });
//   }
// }
// infinitescroll.scolljs();
var infinitescroll = {
  scolljs: function(){
    var endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#AjaxinatePagination',
      //loadingText: document.getElementById('AjaxinatePagination').dataset.text,
      callback: advance,
      //offset: 200
    });
  }
}
infinitescroll.scolljs();
document.addEventListener('scroll', function(e) {
  var totalpage = document.querySelector('#AjaxinatePagination a')?.dataset?.page ?? sessionStorage?.getItem('totalpage');
  sessionStorage.scrollPos = document.documentElement.scrollTop;
  sessionStorage.totalpage = totalpage;
});
// if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
//   var scrollTop=sessionStorage?.getItem('scrollPos')
//   document.documentElement.scrollTop = scrollTop ??  document.body.scrollTop;
//   window.scrollTo(0,0);
//   scrollManualy(scrollTop);
//   function scrollManualy(scrollTop){
//       scrollTop = parseInt(scrollTop);
//       window.scrollTo(0,scrollTop)
//       setTimeout(function(){
//           if(window.scrollY < scrollTop){
//               scrollManualy(scrollTop)
//           }
//       },1000);
//    }
// }
// document.addEventListener('scroll', function(e) {
//   var totalpage = document.querySelector('#AjaxinatePagination a')?.dataset?.page ?? sessionStorage?.getItem('totalpage');
//   sessionStorage.scrollPos = document.documentElement.scrollTop;
//   sessionStorage.totalpage = totalpage;
// });
// if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
//   var scrollTop = sessionStorage?.getItem('scrollPos');
//   var buttonTop = document.querySelector('#AjaxinatePagination');
//   var buttonScroll = buttonTop.offsetTop - window.scrollY;
//   document.documentElement.scrollTop = scrollTop ??  document.body.scrollTop;
//   if(buttonScroll < scrollTop){
//     var buttonScroll = buttonTop.offsetTop - window.scrollY ;
//     scrollManualy(buttonScroll);
//   }else{
//      scrollManualy(scrollTop);
//   }
//   function scrollManualy(scrollTop1){
//     scrollTop1 = parseInt(scrollTop1);
//     window.scrollTo(0,scrollTop1)
//     setTimeout(function(){
//       if(buttonScroll < scrollTop){
//       buttonScroll = buttonTop.offsetTop ;
//         scrollManualy(buttonScroll);
//       } else {
//         window.scrollTo(0,scrollTop)
//         return false;
//       }
//     },500);
//   }
// }
if(document.querySelectorAll('.snippet-promo-image.desk-promo')) document.querySelectorAll('.snippet-promo-image.desk-promo').forEach((promo) => {
  setTimeout(() => {
    let prev = promo.previousSibling;
    promo.style.height = 'calc(100% - '+prev.querySelector('.grid-meta').clientHeight+'px)';
  }, 800);
})